import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import type { PaymentSummary } from "../types/dashboard.types";

interface PaymentDeadlinesCardProps {
	payments: PaymentSummary;
}

export function PaymentDeadlinesCard({ payments }: PaymentDeadlinesCardProps) {
	const navigate = useNavigate();

	return (
		<div className="crm-card">
			<div className="crm-card-head">
				<h3>Muddati yaqin</h3>
				<span className="crm-badge amber">7 kun</span>
			</div>
			<div className="crm-card-body">
				<div className="crm-kv">
					<span>To'lovlar soni</span>
					<b>{payments.dueCount}</b>
				</div>
				<div className="crm-kv">
					<span>Jami summa</span>
					<b>{payments.dueAmount}</b>
				</div>
				<div className="crm-divider" />
				<h4>Kechikkan</h4>
				<div className="crm-kv">
					<span>Qarzdorlar</span>
					<b className="red">{payments.debtorCount}</b>
				</div>
				<div className="crm-kv">
					<span>Jami</span>
					<b className="red">{payments.debtAmount}</b>
				</div>
				<Button
					className="crm-full-btn"
					onClick={() => navigate("/reports/debts", { state: { fromDashboard: true } })}
				>
					Qarzdorlar ro'yxati
				</Button>
			</div>
		</div>
	);
}
